export enum ImageFitMode {
    CONTAIN = 'contain',
    COVER = 'cover'
}
